import Text from '../../../../Text'
import { CalendarGridItemStatus } from '../../../CalendarGridItemStatus'

import { QA_NAME_CALENDAR_GRID_DAY_POPOVER_ROW_SUB_ITEM } from './CalendarGridDayPopoverRowSubItems.constants'

import * as styles from './CalendarGridDayPopoverRowSubItems.module.css'

function CalendarGridDayPopoverRowSubItems({
  getHandleClickSubItem,
  subItems,
}) {
  return (
    <div className={styles.CalendarGridDayPopoverRowSubItems}>
      {subItems.map(subItem => (
        <div className={styles.subItem} key={subItem.id}>
          <Text
            className={styles.label}
            qaName={QA_NAME_CALENDAR_GRID_DAY_POPOVER_ROW_SUB_ITEM}
            onClick={getHandleClickSubItem(subItem)}
          >
            {subItem.title}
          </Text>
          <CalendarGridItemStatus className={styles.status} item={subItem} />
        </div>
      ))}
    </div>
  )
}

export default CalendarGridDayPopoverRowSubItems
